import React, { useRef, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const IoArrowBack = require("react-icons/io5").IoArrowBack;

const kategoriWebOptions = ["Nasional", "Internasional", "Ekonomi", "Teknologi"];
const kategoriOptions = ["analisis", "opini"];

const TambahEditorial = () => {
  const [judul, setJudul] = useState("");
  const [kategori, setKategori] = useState("");
  const [kategoriWeb, setKategoriWeb] = useState("");
  const [deskripsi, setDeskripsi] = useState("");
  const [gambar, setGambar] = useState<File | null>(null);
  const [upload, setUpload] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  const quillRef = useRef<ReactQuill | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("judul", judul);
    formData.append("deskripsi", deskripsi);
    formData.append("kategori", kategori);
    formData.append("kategori_web", kategoriWeb);

    if (gambar) formData.append("gambar", gambar);
    if (upload) formData.append("upload", upload);

    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("token="))
      ?.split("=")[1];

    try {
      setLoading(true);

      Swal.fire({
        title: "Menyimpan...",
        text: "Mohon tunggu",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/editorial`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: "Editorial berhasil ditambahkan",
        timer: 1500,
        showConfirmButton: false,
      });

      setTimeout(() => {
        navigate("/dashboard/editorial");
      }, 1500);
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: err?.response?.data?.message || "Terjadi kesalahan saat menambahkan editorial",
      });
    } finally {
      setLoading(false);
    }
  };

  const modules = {
    toolbar: [[{ header: [1, 2, false] }], ["bold", "italic", "underline", "strike"], [{ list: "ordered" }, { list: "bullet" }], ["clean"]],
  };

  const formats = ["header", "bold", "italic", "underline", "strike", "list", "bullet"];

  const isFormValid = judul && kategori && kategoriWeb && deskripsi;

  return (
    <div className="max-w-3xl mx-auto mt-10 p-6 bg-white rounded shadow">
      <Link to="/dashboard/editorial">
        <div className="flex items-center gap-3 mb-4 text-primary">
          <IoArrowBack />
          <h1 className="text-xl font-bold">Tambah Editorial</h1>
        </div>
      </Link>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Judul */}
        <div>
          <label className="font-semibold">Judul</label>
          <input type="text" className="w-full border px-3 py-2 rounded" value={judul} onChange={(e) => setJudul(e.target.value)} />
        </div>

        {/* Kategori */}
        <div>
          <label className="font-semibold">Kategori</label>
          <select className="w-full border px-3 py-2 rounded bg-white" value={kategori} onChange={(e) => setKategori(e.target.value)}>
            <option value="">-- Pilih Kategori --</option>
            {kategoriOptions.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        {/* Kategori Web */}
        <div>
          <label className="font-semibold">Kategori Web</label>
          <select className="w-full border px-3 py-2 rounded bg-white" value={kategoriWeb} onChange={(e) => setKategoriWeb(e.target.value)}>
            <option value="">-- Pilih Kategori Web --</option>
            {kategoriWebOptions.map((item) => (
              <option key={item}>{item}</option>
            ))}
          </select>
        </div>

        {/* Deskripsi */}
        <div>
          <label className="font-semibold mb-1 block">Deskripsi</label>
          <ReactQuill ref={quillRef} theme="snow" value={deskripsi} onChange={setDeskripsi} modules={modules} formats={formats} />
        </div>

        {/* Gambar */}
        <div>
          <label className="font-semibold">Gambar</label>
          <input type="file" className="w-full border px-3 py-2 rounded bg-white" onChange={(e) => setGambar(e.target.files?.[0] || null)} />
        </div>

        {/* Upload File */}
        {/* <div>
          <label className="font-semibold">Upload File (PDF/DOC opsional)</label>
          <input type="file" className="w-full border px-3 py-2 rounded bg-white" onChange={(e) => setUpload(e.target.files?.[0] || null)} />
        </div> */}

        {/* Submit */}
        <button type="submit" disabled={!isFormValid || loading} className={`w-full py-2 rounded text-white ${isFormValid ? "bg-primary hover:bg-red-500" : "bg-gray-400 cursor-not-allowed"}`}>
          {loading ? "Mengirim..." : "Tambah Editorial"}
        </button>
      </form>
    </div>
  );
};

export default TambahEditorial;
